import React from 'react';

import _ from 'lodash';

export const newLineToBr = str =>
    _.isNil(str)
        ? str
        : str.split('\n').flatMap((s, idx) => idx === 0 ? [s] : [<br key={idx} />, s]);